module.exports = __webpack_public_path__ + "static/media/Heimerl_Logo_Small.3417df8f.png";